module.exports = __webpack_public_path__ + "img/1536076751.73e6b437.jpg";